import { getUserReviews } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetUserReviews(username) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["reviews", "users", `${username}`],
		fn: () => getUserReviews(username),
	});

	const { reviews } = data || { reviews: [] };

	return { reviews, isPending, isSuccess, isError, error };
}
